"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.performPDFDownload = exports.analyzeBomData = void 0;
const httpStatusCodes_1 = __importDefault(require("~/consts/httpStatusCodes"));
const api_1 = require("~/store/api");
const types_1 = require("~/store/types");
const analyzeBomData = (groups) => {
    const bomInfo = {
        hasExtrusions: false,
        hasComponents: false,
        hasPanels: false,
    };
    if (!(groups === null || groups === void 0 ? void 0 : groups.length)) {
        return bomInfo;
    }
    groups.forEach((group) => {
        var _a;
        if (!((_a = group.items) === null || _a === void 0 ? void 0 : _a.length)) {
            return;
        }
        group.items.forEach((item) => {
            var _a;
            if (item.type === types_1.ITEM_TYPE.EXTRUSION && !item.manuallyAdded) {
                bomInfo.hasExtrusions = true;
            }
            if (item.type === types_1.ITEM_TYPE.COMPONENT && !item.manuallyAdded) {
                bomInfo.hasComponents = true;
            }
            const componentTypeName = item.componentType && typeof item.componentType === 'object' ? (_a = item.componentType) === null || _a === void 0 ? void 0 : _a.name : item.componentType;
            if (item.type === types_1.ITEM_TYPE.COMPONENT && componentTypeName === types_1.ITEM_TYPE.PANEL) {
                bomInfo.hasPanels = true;
            }
        });
    });
    return bomInfo;
};
exports.analyzeBomData = analyzeBomData;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const performPDFDownload = (baseOptions, customizationOptions) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        const payload = Object.assign(Object.assign({}, baseOptions), { customizationOptions });
        return yield (0, api_1.downloadPDF)(payload);
    }
    catch (error) {
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === httpStatusCodes_1.default.PAYLOAD_TOO_LARGE &&
            baseOptions.screenShots.panelImages) {
            // Retry without panel images
            // eslint-disable-next-line no-param-reassign
            return (0, exports.performPDFDownload)(Object.assign(Object.assign({}, baseOptions), { screenShots: Object.assign(Object.assign({}, baseOptions.screenShots), { panelImages: null }) }), customizationOptions);
        }
        // Download failed even without panel images or there is some other issue
        throw error;
    }
});
exports.performPDFDownload = performPDFDownload;
